import { render, staticRenderFns } from "./EditRegulator.vue?vue&type=template&id=0627ff80&"
import script from "./EditRegulator.vue?vue&type=script&lang=ts&"
export * from "./EditRegulator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports